import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { LoginModel } from 'projects/core/src/lib/core/model/LoginModel';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { OnboardingPage } from './onboarding.page';

export class OnboardingViewModel {

    constructor() { }

    context: OnboardingPage
    loginModel = new LoginModel()

    getContext(): OnboardingPage {
        return this.context
    }

    setContext(context: OnboardingPage) {
        this.context = context
    }

    async obtemCarroseis() {
        const retorno = await this.loginModel.getCarrosseis();        
        if (retorno.status == ResponseModel.STATUS_OK) {
            return retorno.data
        } else {
            throw Error(ThrowError.MESSAGE_DEFAULT)
        }
    }

}